import { FC } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { getGeneralPagesMetaData } from 'src/utils/seo';
import { Locales } from 'src/utils/localization';
import { getCDNAssetPrefix } from 'src/utils/cdnStaticSourcesHelper';
import { PROD_DOMAIN } from '../api/constants';

const CustomHead: FC = () => {
  const router = useRouter();
  const seoData = getGeneralPagesMetaData(router.route, router?.locale);
  const mainPathPart = `${PROD_DOMAIN}${
    router.locale === Locales.UA ? '' : `/${router.locale}`
  }`;
  const url = `${PROD_DOMAIN}${router?.asPath}`;
  const urlObj = new URL(url);
  const cdnAssetPrefix = getCDNAssetPrefix();
  const getPathValue = () => {
    if (
      (router?.asPath === '/' || urlObj?.pathname === '/') &&
      router.locale === Locales.UA
    ) {
      return '/';
    }
    if (router?.asPath === '/' || urlObj?.pathname === '/') {
      return '';
    }
    return urlObj?.pathname;
  };
  const path = getPathValue();
  const alternatePath = router?.asPath === '/' ? '' : router?.asPath;

  return (
    <Head>
      <meta name="description" content={seoData.description} />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1"
      ></meta>
      <title>{seoData.title}</title>
      <link rel="canonical" href={`${mainPathPart}${path}`} />
      <link
        data-n-head="ssr"
        data-hid="alternate-hreflang-uk"
        rel="alternate"
        href={`${PROD_DOMAIN}${alternatePath}`}
        hrefLang="uk"
      />
      <link
        data-n-head="ssr"
        data-hid="alternate-hreflang-ru"
        rel="alternate"
        href={`${PROD_DOMAIN}/${Locales.RU}${alternatePath}`}
        hrefLang="ru"
      />
      <link
        data-n-head="ssr"
        data-hid="alternate-hreflang-uk"
        rel="alternate"
        href={`${PROD_DOMAIN}${alternatePath}`}
        hrefLang="x-default"
      />
      {cdnAssetPrefix && (
        <>
          <link rel="preconnect" href={cdnAssetPrefix} />
          <link rel="dns-prefetch" href={cdnAssetPrefix} />
        </>
      )}
    </Head>
  );
};
export default CustomHead;
